/** Body copy for the guest-login wrong-portal card. */
export const WRONG_PORTAL_STAFF_BODY =
  "Travel Agents, Group Leaders, Travel Ambassadors, Non-Profits, and Staff, please click the button below to log into your account.";

export const WRONG_PORTAL_STAFF_BUTTON_LABEL =
  "Sign in as a Travel Agent, Group Leader, Travel Ambassador, Non-Profit, or Staff";

export function formatWrongPortalAccountHeadline(
  emailAddress: string,
  accountTypeLabel: string
): string {
  return `The email (${emailAddress}) is associated with a ${accountTypeLabel} account`;
}

/**
 * Map a role name to the account-type label shown on the guest login wrong-portal card.
 * Internal/admin roles collapse to "Staff".
 */
export function resolveWrongPortalAccountTypeLabel(
  roleName: string | null | undefined
): string {
  const name = (roleName ?? "").trim();

  switch (name) {
    case "Travel Agent":
    case "Booking Agent":
      return "Travel Agent";
    case "Group Leader":
      return "Group Leader";
    case "Travel Ambassador":
      return "Travel Ambassador";
    case "Non-Profit":
      return "Non-Profit";
    default:
      return "Staff";
  }
}
